import { styled } from '@mui/material';
import { IconButton, Box } from '@mui/material';
import { CLOSED_DRAWER_WIDTH, HEADER_HEIGHT } from '@/lib/constants/generalConstants';
import _RefreshArrows from '@/assets/images/icons/refresh_arrows.svg?react';
import _EyeOnIcon from '@/assets/images/icons/header-eye-on.svg?react';
import _EyeOffIcon from '@/assets/images/icons/header-eye-off.svg?react';
import _NotificationIcon from '@/assets/images/icons/header-notifications.svg?react';
import _LanguageIcon from '@/assets/images/icons/header-language.svg?react';
import _ErrorOutlineRoundedIcon from '@/assets/images/icons/error_outline_rounded_icon.svg?react';

export const HeaderToolBar = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    width: '100%',
});

export const HeaderToolBarMobile = styled(HeaderToolBar)(({ theme }) => ({
    justifyContent: 'space-between',
    padding: '0 16px',
    background: theme.palette.primitives.woodsmoke[1000],
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));

export const DefaultIconButton = styled(IconButton)({
    marginRight: '24px',
    '&:last-child': {
        marginRight: 0,
    },
});

export const profileMenuProps = {
    elevation: 0,
    sx: {
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? 'backgrounds.bg2' : 'backgrounds.bg1',
        mt: 1.5,
        '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? 'backgrounds.bg2' : 'backgrounds.bg1',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
        },
    },
};

export const MenuCategory = styled(Box)({});
export const UserNameBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    padding: '0 16px',
    marginTop: '16px',
});

export const FixedHeaderWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    padding: `0 0 0 ${CLOSED_DRAWER_WIDTH}px`,
    margin: 0,
    position: 'fixed',
    top: 0,
    left: 0,
    height: `${HEADER_HEIGHT}px`,
    backgroundColor: theme.palette.backgrounds.bg1,
    borderStyle: 'solid',
    borderColor: '#3C3C3C',
    borderBottomWidth: '1px',
    zIndex: 11,
}));

export const FixedHeaderContent = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '6px 24px',
    backgroundColor: 'transparent',
});

export const RefreshArrows = styled(_RefreshArrows)(({ theme }) => ({
    width: '18px',
    height: '18px',
    path: { fill: theme.palette.secondary.main },
}));

export const EyeOnIcon = styled(_EyeOnIcon)(() => ({}));
export const EyeOffIcon = styled(_EyeOffIcon)(() => ({}));
export const NotificationIcon = styled(_NotificationIcon)(() => ({}));
export const LanguageIcon = styled(_LanguageIcon)(() => ({}));
export const ErrorOutlineRoundedIcon = styled(_ErrorOutlineRoundedIcon)({
    width: '16px',
    height: '16px',
});
